import {Component, tag} from 'doz'

@tag('logo-logo')
export default class extends Component {
    template(h) {
        //language=HTML
        return h`
            <style>
                .container {
                    text-align: center;
                    padding: 0;
                    color: ${this.THEME.primaryColor};
                    background: ${this.THEME.onPrimaryColor};
                }
                
                .logo {
                    width: 120px;
                    margin: 10px 0px;
                }
            </style>
            <div class="container" d-show="${(this.PLAYER_CONFIG.showLogo && !this.PLAYER_CONFIG.isShowProgramsOnly && (this.PLAYER_CONFIG.logoChannelUrl || this.PLAYER_CONFIG.appIconUrl))}" >
                <img class="logo" alt="${this.PLAYER_CONFIG.title + ' logo'}" src="${this.PLAYER_CONFIG.logoChannelUrl || this.PLAYER_CONFIG.appIconUrl}">
            </div>
        `
    }
}